// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".certificate-settings-item-form--layout {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 76px;\n  padding: 8px;\n  border-radius: 8px;\n  border: 1px solid var(--gray-400); }\n  .certificate-settings-item-form--layout .certificate-settings-item-form--check {\n    display: flex;\n    align-items: center;\n    gap: 8px; }\n", ""]);
// Exports
module.exports = exports;
